
export default {
  name: 'StateItem',
  components: {},
  props: ['item'],
  data () {
    return {

    }
  },
  computed: {
  },
  mounted () {

  },
  methods: {
    selectState () {
      this.$store.dispatch('selectState', { id: this.item.code, name: this.item.stateName })
      this.$router.push({ name: 'FetchBillWeb', params: { category: this.$route.params.category } })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/StateItemWeb/component.js